export default __webpack_public_path__ + "static/media/Recovering Layoff.0c4a1580.png";